import React, { useState } from 'react';
import { MenuItem, TextField, ListSubheader, InputAdornment } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

const MENU_HEIGHT = 260;

// A dropdown that opens at a fixed height, scrolls inside it, and keeps a search box pinned at the top.
// options: [{ value, label, muted? }]; a muted option (e.g. "Department…") is always shown, the rest are filtered by
// what is typed; an option's optional `hint` shows as a small line under its label. `sx` styles the closed field,
// the same way as on a plain TextField.
export default function SearchSelect({ value, onChange, options, sx, disabled, error, label, searchPlaceholder = 'Search…' }) {
    const [q, setQ] = useState('');
    const needle = q.trim().toLowerCase();
    const shown = options.filter((o) => o.muted || !needle || String(o.label).toLowerCase().includes(needle));
    const hasMatch = shown.some((o) => !o.muted);
    return (
        <TextField
            select fullWidth size="small" value={value} onChange={onChange} sx={sx} disabled={disabled} error={error} label={label}
            slotProps={{
                ...(label ? { inputLabel: { shrink: true } } : {}),
                select: {
                    displayEmpty: true,
                    MenuProps: {
                        autoFocus: false,
                        slotProps: {
                            paper: { sx: { maxHeight: MENU_HEIGHT, overflowY: 'auto', border: '1px solid #E6EAF1' } },
                            transition: { onExited: () => setQ('') },
                        },
                    },
                    renderValue: (v) => {
                        const o = options.find((x) => String(x.value) === String(v));
                        return o ? <span style={o.muted ? { color: '#94A3B8' } : undefined}>{o.label}</span> : '';
                    },
                },
            }}
        >
            <ListSubheader sx={{ bgcolor: '#fff', p: 1, lineHeight: 'normal' }}>
                <TextField
                    autoFocus size="small" fullWidth placeholder={searchPlaceholder} value={q}
                    onChange={(e) => setQ(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => { if (e.key !== 'Escape') e.stopPropagation(); }}
                    slotProps={{ input: { startAdornment: <InputAdornment position="start"><SearchRoundedIcon sx={{ fontSize: 18, color: '#64748B' }} /></InputAdornment> } }}
                />
            </ListSubheader>
            {shown.map((o) => (
                <MenuItem key={String(o.value)} value={o.value} sx={{ fontSize: 13, ...(o.muted && { color: '#94A3B8' }) }}>
                    {o.hint ? (
                        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
                            {o.label}
                            <span style={{ fontSize: 11.5, color: '#B7791F', fontWeight: 600 }}>{o.hint}</span>
                        </span>
                    ) : o.label}
                </MenuItem>
            ))}
            {!hasMatch && needle && <MenuItem disabled sx={{ fontSize: 13 }}>No matches</MenuItem>}
        </TextField>
    );
}
